import script from "./DynamicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicForm.vue?vue&type=script&setup=true&lang=js"

import "./DynamicForm.vue?vue&type=style&index=0&id=041c8a59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041c8a59"]])

export default __exports__